<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="aliasForm" *ngIf="aliasForm !== null">
		<div class="grid">
			<div class="col-12" *ngFor="let alias of listAlias">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f[alias.Id], 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f[alias.Id], 'label')">{{
						translateData(alias.DefaultDescription) }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f[alias.Id], 'borderInput')">
						<input type="text" pInputText [class]="onExtendedMobile() ? 'pl-6' : ''"
							[ngClass]="dynamicInputTextWidth()" [formControlName]="alias.Id" maxlength="50" />
						<p-button pTooltip="{{ 'RESTORE_DEFAULT' | translate }}" tooltipPosition="bottom" icon="pi cm-reload"
							styleClass="p-1" (click)="restoreDefault(alias)" [rounded]="false" [text]="true" severity="danger">
						</p-button>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f[alias.Id])" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'INVALID_NAME' |
					translate }}</small>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>